function time_to_read() {
	// Get all the content from the appropriate container
	const contentArea = document.querySelectorAll('.wysiwyg, .fifty .text');

	if (!contentArea.length) return;

	contentArea.forEach((area) => {
		// Get the text content
		const text = area.textContent || area.innerText;

		// Calculate reading time (average reading speed: 200-250 words per minute)
		const wordsPerMinute = 250;
		const wordCount = text.trim().split(/\s+/).length;
		const readingTime = Math.max(1, Math.ceil(wordCount / wordsPerMinute));

		// Update the reading time element
		const readingTimeElement = document.querySelector('.reading-time span');

		if (readingTimeElement) {
			readingTimeElement.textContent = readingTime + ' min read';
		}
	});
}
time_to_read();
document.addEventListener('DOMContentLoaded', time_to_read);

function initSearchOverlay() {
	const searchToggle = document.querySelector('.search-toggle');

	if (!searchToggle) return;

	const searchOverlay = document.querySelector('.search-overlay');
	const searchClose = document.querySelector('.search-close');
	const searchInput = searchOverlay.querySelector('.search-field');

	// Open search overlay
	if (searchToggle) {
		searchToggle.addEventListener('click', function (e) {
			e.preventDefault();
			searchOverlay.classList.add('active');
			// Focus on the input field when overlay is shown
			setTimeout(() => {
				searchInput.focus();
			}, 100);
		});
	}

	// Close search overlay
	if (searchClose) {
		searchClose.addEventListener('click', function () {
			searchOverlay.classList.remove('active');
		});
	}

	// Close on Escape key
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
			searchOverlay.classList.remove('active');
		}
	});

	// Submit on Enter key
	searchInput.addEventListener('keydown', function (e) {
		if (e.key === 'Enter') {
			e.target.closest('form').submit();
		}
	});
}

// Initialize when DOM is ready
initSearchOverlay();
// document.addEventListener('DOMContentLoaded', initSearchOverlay);
